import * as React from 'react'
import { DragSource } from 'react-dnd'
import { connect } from 'react-redux'
import type { Group } from 'types/group'
import * as ItemTypes from '@disco/constants/ItemTypes'
import { makeGetGroupLocks } from '@disco/state-management/selectors/groups'
const groupSource = {
  beginDrag: ({ group }) => ({
    group,
  }),
  canDrag: ({ locked, group }) => !locked || !group.parent, // block only folders from dragging
}
type Props = {
  group: Group
  connectDragSource: (...args: Array<any>) => any
  isDragging: boolean
  children: React.ReactNode
}

class CustomGroupDragWrapper extends React.Component<Props> {
  render() {
    const { isDragging, connectDragSource } = this.props
    return connectDragSource(
      <div
        style={{
          opacity: isDragging ? 0.5 : 1,
        }}
      >
        {this.props.children}
      </div>,
    )
  }
}

const dragSource = DragSource(
  ItemTypes.GROUP,
  groupSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }),
)(CustomGroupDragWrapper)
export default connect((state, props: Props) => {
  const getGroupLocks = makeGetGroupLocks()
  return {
    locked:
      getGroupLocks(state, {
        groupId: props.group.id,
      })?.lock_structure ?? false,
  }
})(dragSource)
